import { render } from "./event_results_panel.vue?vue&type=template&id=bf3b0d4a"
import script from "./event_results_panel.vue?vue&type=script&lang=js"
export * from "./event_results_panel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__